import { IRecoveryConfirmRequest, RecoveryRequest, RecoveryResponse } from "@/app/globalContext/recovery.interface";

const API_BASE_URL = process.env.NEXT_PUBLIC_HOME_BASE_API;

export const recoveryService = {
	async sendRecoveryCode(input: RecoveryRequest): Promise<RecoveryResponse> {
		
		try {

			const response = await fetch(`${API_BASE_URL}/recovery`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'captcha-token': input?.recaptchaToken ?? '',
					'captcha-action': 'get_recovery_code',
				},
				body: JSON.stringify(input),
			});

			const requestResponse = await response.json();
			return {
				statusCode: requestResponse.statusCode ?? requestResponse.status,
				...requestResponse,
			}

		} catch (ex) {
			console.log(`Error: ${ex}`)
			return {
				email: '',
				recoveryToken: '',
				statusCode: 500,
				message: "Ha ocurrido un error en el servidor",
				recoveryAttemptsLeft: 0
			}
		}
	},
	
	async recoveryConfirm(input: IRecoveryConfirmRequest): Promise<{ status: number; message: string; data: { message: string } }> {
		try {
			const { id, ...inputReq } = input;

			const response = await fetch(`${API_BASE_URL}/recovery/${input.id}`, {
				method: 'PUT',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(inputReq),
			});

			if (!response.ok) {
				const errorData = await response.json();
				return {
					status: response.status,
					message: errorData.message || 'Error al confirmar la recuperación de contraseña',
					data: { message: errorData.message || 'Error al confirmar la recuperación de contraseña' },
				};
			}

			const responseData = await response.json();
			return {
				status: response.status,
				message: 'Contraseña recuperada exitosamente',
				data: { message: responseData.message || 'Contraseña recuperada exitosamente' },
			};

		} catch (ex) {
			return {
				status: 500,
				message: 'Ha ocurrido un error en el servidor',
				data: { message: 'Error al confirmar la recuperación de contraseña' },
			};
		}
	},

	// **Nuevo método para verificar el token**
	async verifyToken(token: string): Promise<{ status: number; message: string; data: any }> {
		try {
			const response = await fetch(`${API_BASE_URL}/account/verify-token/${token}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
				},
			});

			if (!response.ok) {
				const errorData = await response.json();
				return {
					status: response.status,
					message: errorData.message || 'Error al validar el token',
					data: null,
				};
			}

			const responseData = await response.json();
			return {
				status: response.status,
				message: 'Token validado exitosamente',
				data: responseData,
			};

		} catch (ex) {
			console.log(`Error: ${ex}`);
			return {
				status: 500,
				message: 'Ha ocurrido un error en el servidor',
				data: null,
			};
		}
	},

};